<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text">
            Ver Caja de ahorro Folio:{{folio}}
            <div>
              <router-link :to="{
                      name: 'EditCajaAhorro',
                      params: {
                        folio: folio,
                        config: config
                      }
                    }">
                <CButton v-if="false" color="success" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-pencil" />Editar
                </CButton>
              </router-link>
              <CButton color="info" class="mr-1 btn-header" @click="getReporte">
                <i v-if="loader" class="fa fa-spinner fa-pulse mr-1"></i>
                <CIcon v-else class="mr-1" :name="`cil-cloud-download`" />PDF
              </CButton>
              <router-link :to="{ name: 'CajaAhorro', params: { config: config } }">
                <CButton color="primary" class="mr-1 btn-header">
                  <CIcon class="mr-1" name="cil-arrow-thick-left" />Regresar
                </CButton>
              </router-link>
            </div>
          </CCardHeader>
          <CCardBody v-if="isLoading">
            <div class="w-100 d-flex justify-content-center align-items-center">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div>
          </CCardBody>
          <CCardBody v-else>
            <CCol sm="12" class="text-right">
              {{ this.item.author.correo }}
            </CCol>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha:</label>
                <CInput v-model="fechaHora" disabled type="text" :horizontal="{ input: 'col-sm-12' }" />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput :value.sync="trabajador" :label="`Trabajador: `" disable placeholder="Concepto..." type="text" />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha inical:</label>
                <CInput v-model="fechaInicial" disabled type="text" :horizontal="{ input: 'col-sm-12' }" />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label>Fecha fin:</label>
                <CInput v-model="fechaFin" disabled type="text" :horizontal="{ input: 'col-sm-12' }" />
              </CCol>
            </CRow>

            <CRow>
              <CCol sm="12" md="9" lg="9">
                <CInput :value.sync="monto" :label="`Monto semanal: `" disable placeholder="Concepto..." type="text" />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label><b>Prorrogas:</b></label>
                <ul>
                  <li v-if="prorrogas.length <= 0" > N / A </li>
                  <li v-for="(prorroga, index) in prorrogas" :key="index">{{ prorroga }}</li>
                </ul>
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <label><b>Pagos:</b></label>
                <ul>
                  <li v-if="pagos.length <= 0" > N / A </li>
                  <li v-for="(pago, index) in pagos" :key="index"> Fecha : {{ pago.fecha }} , Monto : {{ pago.monto }}</li>
                </ul>
              </CCol>
            </CRow>
            <CRow>
              <CCol>
                <label>Comentarios:</label>
                <CTextarea v-model="comentarios" disabled horizontal />
              </CCol>
            </CRow>
            <CRow>
              <CCol sm="12" md="9" lg="9">
                <KlayFileDD
                  :fetching="fetching"
                  v-model="medias"
                  :label="`Anexos: `"
                  @onFetch="onFetch"
                  @onErrorFetch="(err)=>{
                    fetching=false;
                    error=err
                    warningModal=true
                  }"
                  :fetchMethod="pushMedia"
                  :baseSrc="$store.getters.MediaGet"
                />
              </CCol>
            </CRow>
            <CRow>
              <CButton v-if="fetching" class="px-4 mx-3 btn-lg" color="success">
                <i class="fa fa-spinner fa-pulse"></i>
              </CButton>
              <CButton v-else @click="()=>{fetching=true}" class="px-4 mx-3 btn-lg" color="success">
                <span>Actualizar</span>
              </CButton>
            </CRow>
            <CModal
              size="sm"
              title="Caja de ahorro"
              :centered="true"
              color="warning"
              :show.sync="warningModal"
            >{{ error }}</CModal>
            <CModal
              size="sm"
              title="Caja de ahorro"
              :centered="true"
              color="success"
              :show.sync="successModal"
              >Guardado con éxito.
              <template #footer>
                <CButton @click="successModal = false"  color="success">Aceptar</CButton>
              </template>
            </CModal>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>


export default {
  name: "VerCajaAhorro",

  components: {
    
  },

  data() {
    return {
      folio: this.$route.params.id,
      config: this.$route.params.config,
      
      fechaHora :'',
      trabajador : '',
      monto : '',
      fechaInicial : '',
      fechaFin : '',
      prorrogas : [],
      pagos : [],
      comentarios: '',
      successModal: false,
      warningModal: false,
      error: "",
      isLoading: false,
      isLoadingPage: false,
      currentAlertCounter: 0,
      fetching: false,
      medias:[],
      loader: false,
    };
  },

  computed: {
    ubicacionRaiz() {
      return this.$store.state.rootLocation ?
        this.$store.state.rootLocation.value :
        "";
    }
  },

  created() {
    this.isLoading = true;
    this.$store.dispatch("customDocumentoHTTP", {
        schema: "caja_de_ahorro",
        filter: {
            wherein: [{
                field: "payload->encabezado->ubicacion_raiz_id",
                value: [this.ubicacionRaiz]
            }],
            where: [{
              field: "folio",
              value: this.folio,
              operator: "="
            }]
        },
        ["with-storage"]: ["*"]
    })
    .then((res) => {
        this.item = res.data[0]
        let cajaAhorro = res.data[0].payload;
        this.trabajador = cajaAhorro.encabezado._relaciones.trabajador.payload.nombre;
        this.fechaHora = (cajaAhorro.encabezado.fechahora).split(' ')[0];
        this.fechaInicial = cajaAhorro.encabezado.fecha_inicial;
        this.prorrogas = cajaAhorro.prorrogas.fechas;
        this.pagos = (cajaAhorro.pagos) ? cajaAhorro.pagos : [];
        this.fechaFin = cajaAhorro.encabezado.fecha_final;
        this.comentarios = this.item.payload.encabezado.comentarios;
        this.medias = this.item.payload.anexos;
        this.monto = (cajaAhorro.encabezado.monto).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,",");
    }).catch(rej => {
        console.log(rej);
    }).finally(() => {
        this.isLoading = false;
    });
  },

  methods: {
    getReporte(){
      if(this.loader){
        return
      }
      this.loader = true
      this.$forceUpdate();
      const reportCall = {
        reporte: "formato_caja_de_ahorro",
        params: { folio:this.$route.params.id, ubicaciones: [this.ubicacionRaiz]},
        pdf : true
      };

      // console.log(reportCall);
      // call.push(reportCall);

      
        this.$store.dispatch("reportsPDFHttp", {
          ...reportCall
        }).then(res => {

          const blob = res;

          let a = document.createElement("a");
          a.style = "display: none";
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = "Reporte caja de ahorro.pdf";
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
        })

        .finally(() => {
          this.loader = false
          this.$forceUpdate();
        });
    },
    async onFetch(medias){
      this.fetching=false
      const {folio,serie,schema,payload} = this.item
      const body = Object.assign({},JSON.parse(JSON.stringify({folio,serie,schema,payload})))
      body.payload.anexos = medias
      delete body.payload.encabezado._relaciones
      this.$store.dispatch("customDocumentoRemplazarHTTP",body)
        .then(()=>{
          this.currentAlertCounter = 6;
            // console.log(res.data);
            // this.$router.push({ name: "Produccion" });
        })
        .catch(rej => {
          // console.log(rej);
          this.error = rej.message;
          this.warningModal = true;
          this.fetching=false
          return;
        })

        .finally(() => {
          this.fetching=false
          if (!this.warningModal) {
            this.successModal = true;
          }
        });
      
    },
    async pushMedia(files) {
      const arr = [];
      
      for (const v of files.map(async (m) => {
        // eslint-disable-next-line no-extra-boolean-cast
        if(!!m.media){
          return Promise.resolve({data:m,status:"success"})
        }
        const formData = new FormData();
        formData.append("media", m);
        const promise = await this.$store.dispatch("customImageHTTP", formData);

        return promise;
      })) {
        const media = await v;
        if (media.status === "success") {
          arr.push(media.data);
        }
      }
      return arr;
      /*
        const formData = new FormData()
        formData.append('media', format.dataURLtoFile(this.fileList[0].thumbUrl))
        this.$store.dispatch('MEDIA_CARGAR', formData)
      */
    },
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}

.line {
  color: #321fdb;
  /* old IE */
  background-color: #321fdb;
  /* Modern Browsers */
}

@media (max-width: 420px) {
  .btn-header {
    padding-left: 8px;
    padding-right: 8px;
    font-size: 12px;
  }

  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }

  .text-sm {
    font-size: 11px !important;
  }

  .margin-sm {
    margin: 5px;
  }
}
</style>
